


















































import settings from '@/settings'
import n from '@/utils/notifications'
import m from '@/graphql/mutation'
import q from '@/graphql/query'
import Menus from '@/components/menus'

export default {
    name: 'distributor_companies_list'

    components: { Menus }

    data: ()->
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        distributions: []

    computed:
        data_filtered: ()->
            self = @
            data = @distributions.filter (x) ->
                siret = ape_naf_code = city = ''
                if x.distribution.company.siret != null
                      siret = x.distribution.company.siret.toLowerCase()
                if x.distribution.company.ape_naf_code != null
                      ape_naf_code = x.distribution.company.ape_naf_code.toLowerCase()
                if x.distribution.company.city != null
                      city = x.distribution.company.city.toLowerCase()
                !self.search || x.distribution.company.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.distribution.company.name.toLowerCase().includes(self.search.toLowerCase())\
                || x.distribution.company.reference.toLowerCase().includes(self.search.toLowerCase()) \
                || siret.includes(self.search.toLowerCase()) \
                || ape_naf_code.includes(self.search.toLowerCase()) \
                || city.includes(self.search.toLowerCase()) \
                || x.distribution.distributed_by.company.name.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

    methods:
        logo_url: (row)->
            url = ""
            if row.distribution.company.logo != ""
                url = settings.media_url+row.distribution.company.logo_dir+"/"+row.distribution.company.logo
            return url

        table_row_class_name: ({ row, row_index })->
            if !row.distribution.company.is_active
                return 'warning-row'
            return ''

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            props = prop.split('.')
            @distributions.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                field_a = field_b = ""
                if prop != 'distribution.distributed_by.company.name'
                    if a[props[0]][props[1]][props[2]] != null
                        field_a = a[props[0]][props[1]][props[2]]
                    if b[props[0]][props[1]][props[2]] != null
                        field_b = b[props[0]][props[1]][props[2]]
                    return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier
                else
                    return a[props[0]][props[1]][props[2]][props[3]].toLowerCase().localeCompare(b[props[0]][props[1]][props[2]][props[3]].toLowerCase())*modifier
            # console.log "DISTRIBUTIONS SORT ", @distributions

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        active_title: (is_active)->
            title = "Activer la société"
            if is_active
                title = "Bloquer la société"
            return title

        change_selected_company: (distribution)->
            # console.log 'COMPANIES LIST ', distribution.uid
            @$store.commit('set_selected_company', distribution.company)
            localStorage.setItem("selected_company", JSON.stringify(distribution.company))
            return

        de_activate_company: (distribution_uid, company)->
            # console.log "DE ACTIVATE ", company.is_active
            confirm_text = 'activer'
            new_active = true
            if company.is_active
                confirm_text = 'bloquer'
                new_active = false
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir "+confirm_text+" cette société ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "COMPANY DE ACTIVATE", company.uid
                    for d in self.distributions
                        if d.distribution.uid == distribution_uid
                            d.distribution.company.is_active = new_active
                            break
                    self.$http.post(settings.change_active, {"company_uid":company.uid})
                    .then (resp)->
                        if resp.body.status == "ok"
                            n.success()
                        else
                            n.error("distributor_companies_list: de_activate_company: then", resp.body.message)
                .catch (cancel)->
                    return

        distributions_factory: (distribution, count)->
            # to prevent error in data_filtered():
            if distribution.distributed_by is null
                distribution.distributed_by = {
                    uid:''
                    company:{
                        uid:''
                        name:''
                    }
                }
            @distributions.push({distribution:distribution, count:count})
            count++
            for key, value of distribution.children
                @distributions_factory(value, count)
            # console.log "DISTRIBUTIONS FACTORY", JSON.stringify(@distributions)
            return

        get_distributions: ()->
            self = @
            q.run('get_distribution_set', [@$store.state.user_datas.company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("distributor_companies_list: get_distributions: then", e.message)
                else
                    # console.log "GET DISTRIBUTIONS", resp.body.data.distributions_filtered
                    self.distributions_factory(resp.body.data.distribution_set[0], 1)
            .catch (resp)->
                n.catch_error(resp, "distributor_companies_list: get_distributions()")

    beforeMount: ()->
        @get_distributions()
}
